<template>
  <section class="ma-8">
    <t-page-title title="Mapeamento | Criar" />
    <v-row justify="center" align="center">
      <v-col cols="12">
        <v-card class="pa-8">
          <form-mapping v-model="model" @submit="submit" />
        </v-card>
      </v-col>
      <v-col v-if="model.sectors" cols="12">
        <v-card class="pa-8">
          <form-sector v-model="model.sectors" @delete="deleted => model.sectors = model.sectors?.filter(s => s !== deleted)" />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import TPageTitle from '@/components/TPageTitle.vue'
import Mapping, { MappingPayload } from '@/types/Mapping'
import MappingService from '@/services/MappingService'
import { useSnackBar } from '@/stores/snackbar'
import { useLoader } from '@/stores/loader'
import { useRouter } from 'vue-router'
import FormMapping from './form-mapping.vue'
import FormSector from './form-sector.vue'
import { mappingFormData } from '@/helpers/mappingForm'
import { ref } from 'vue'
import Local from '@/types/Local'
import Sector from '@/types/Sector'

const snackbar = useSnackBar()
const loader = useLoader()
const router = useRouter()

const model = ref<Mapping>({
  name: '',
  image_url: '',
  has_sector_selection: false,
  local: {
    id: '',
  } as Local,
  sectors: [] as Sector[],
} as Mapping)

async function submit(payload: MappingPayload) {
  if ((model.value.sectors ?? []).length <= 0) {
    snackbar.show(
      'O Mapeamento precisa ter pelo menos um setor',
      'warning',
    )
    return
  }

  try {
    loader.increment()
    model.value.sectors!.forEach((sector, index) => {
      sector.order = index
    })

    await (new MappingService()).store(mappingFormData(payload, payload.image))

    snackbar.show(
      'Mapeamento criado com sucesso',
      'success',
    )

    router.push({ name: 'list-mappings' })
  } finally {
    loader.decrement()
  }
}
</script>
